export enum E_NOTIFICATION_REACTION_ACTION {
  ADD = "ADD",
  CHANGE = "CHANGE",
  REMOVE = "REMOVE"
}

export enum E_NOTIFICATION_TYPE {
  KHATTABAT_CONVERSATION_MESSAGE = "khattabat_conversation_message",
  KHATTABAT_CONVERSATION_MESSAGE_REACTION = "khattabat_conversation_message_reaction",
  KHATTABAT_CONVERSATION_MESSAGE_READ = "khattabat_conversation_message_read",
  KHATTABAT_NEW_CLIENT_TO_BE_ASSIGNED = "khattabat_new_client_to_be_assigned",
  KHATTABAT_NEW_CLIENT_ASSIGNED = "khattabat_new_client_assigned",
  KHATTABAT_CLIENT_PAID_PHASE = "khattabat_client_paid_phase",
  KHATTABAT_REMUNERATION_UPDATE = "khattabat_remuneration_update",
  KHATTABAT_CLIENT_SUBSCRIPTION_RENEWED = "khattabat_client_subscription_renewed",
  KHATTABAT_CONVERSATION_DELETED = "khattabat_conversation_deleted",
  KHATTABAT_CONVERSATION_EXITED = "khattabat_conversation_exited",
  KHATTABAT_CONVERSATION_ACCEPTED = "khattabat_conversation_accepted"
}
